export const DASHBOARDS_ADMIN_DEFAULT_LIMIT = 20;
export const DASHBOARDS_ADMIN_MAX_LIMIT = 100;
export const DASHBOARDS_ADMIN_FORMAT = "json";

/**
 * @param {{
 *   page?: number,
 *   limit?: number,
 *   search?: string,
 *   category?: string,
 *   tickers?: string[],
 *   sectors?: string[],
 *   industries?: string[],
 *   favourite?: boolean,
 *   isCorporateAssigned?: boolean,
 * }} options
 */
export const buildDashboardsAdminParams = ({
  page = 1,
  limit = DASHBOARDS_ADMIN_DEFAULT_LIMIT,
  search,
  category,
  tickers,
  sectors,
  industries,
  favourite,
  isCorporateAssigned,
} = {}) => {
  const params = {
    page: Math.max(1, Number(page) || 1),
    limit: Math.min(DASHBOARDS_ADMIN_MAX_LIMIT, Math.max(1, Number(limit) || DASHBOARDS_ADMIN_DEFAULT_LIMIT)),
    format: DASHBOARDS_ADMIN_FORMAT,
  };

  const q = String(search || "").trim();
  if (q) params.search = q;

  const cat = String(category || "").trim();
  if (cat) params.category = cat;

  if (Array.isArray(tickers) && tickers.length > 0) {
    params.tickers = tickers.map(String).filter(Boolean);
  }

  if (Array.isArray(sectors) && sectors.length > 0) {
    params.sectors = sectors.map(String).filter(Boolean);
  }

  if (Array.isArray(industries) && industries.length > 0) {
    params.industries = industries.map(String).filter(Boolean);
  }

  if (favourite === true) {
    params.favourite = true;
  }

  // Corporate view: any dashboard with corporate assignees (pure corporate + mixed).
  // Send as string so Nest ParseBoolPipe receives a boolean string query value.
  if (isCorporateAssigned === true) {
    params.isCorporateAssigned = "true";
  }

  return params;
};

/** Axios serializer: `tickers=A&tickers=B&sectors=X` (Nest-style repeated keys). */
export const dashboardsAdminParamsSerializer = {
  indexes: null,
};
